import React, { useEffect, useState } from "react"
import logo from "../../asserts/boost-detailing-logo.png"
import Tostify from "../ToastifyNotify/Tostify"
import { useNavigate } from "react-router-dom"

const Navbar = () => {
  const navigate = useNavigate()

  return (
    <>
      <Tostify />
      <div className="p-3 space-x-2 bg- black flex items-center justify-between md:justify-center rounded-b-lg shadow-md shadow-black">
        <a
          href="https://boostmobiledetailing.ca/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="logo" className="w-14" />
        </a>
        {/* <div className="">
          <a
            className="bg-yellow-medium_dark text-sm py-2 px-2 rounded hover:shadow-md hover:shadow-white"
            href="https://boostceramic.ca/"
            target="_blank"
            rel="noreferrer"
          >
            Boost Ceramic
          </a>
        </div> */}
        <div className="space-x-1">
          <a
            className="bg-yellow-medium_dark text-sm py-2 px-2 rounded hover:shadow-md hover:shadow-white"
            href="https://boostmobiledetailing.ca/"
            target="_blank"
            rel="noreferrer"
          >
            Boost Detailing
          </a>
          <button
            className="bg-yellow-medium_dark text-sm py-2 px-2 rounded hover:shadow-md hover:shadow-white"
            onClick={() => {
              navigate("gift-card")
            }}
          >
            Gift Card
          </button>
          <button
            className="bg-yellow-medium_dark text-sm py-2 px-2 rounded hover:shadow-md hover:shadow-white"
            onClick={() => {
              navigate("booking")
            }}
          >
            Book Now
          </button>
        </div>
      </div>
    </>
  )
}

export default Navbar
